// 订单菜单接口
import axios from 'axios'

/**
 * 管理端-通过订单ID创建寄出快递订单
 * @param {Object} data { id: 订单LongId, beginTime?: 新预约取件时间 }
 */
export function createSenderOrder(data) {
    return axios({
        url: '/api/oms/order/createSenderOrder',
        method: 'POST',
        data
    })
}

/**
 * 管理端-通过订单ID创建寄回快递订单
 * @param {Object} data { id: 订单LongId }
 */
export function createReceiveOrder(data) {
    return axios({
        url: '/api/oms/order/createReceiveOrder',
        method: 'POST',
        data
    })
}